import { render, staticRenderFns } from "./UpgradePlansView.vue?vue&type=template&id=2a500a22&"
import script from "./UpgradePlansView.vue?vue&type=script&lang=js&"
export * from "./UpgradePlansView.vue?vue&type=script&lang=js&"
import style0 from "./UpgradePlansView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports